import * as THREE from "three";
const textureLoader = new THREE.TextureLoader();
export const woodMap = textureLoader.load('https://static.3dp.deallog.pro/real.jpg');
export const woodNormal = textureLoader.load('https://static.3dp.deallog.pro/gray.jpg');
// обязательно
woodMap.wrapS = woodMap.wrapT = THREE.RepeatWrapping;
woodNormal.wrapS = woodNormal.wrapT = THREE.RepeatWrapping;
// масштаб текстуры (подбираешь)
woodMap.repeat.set(1, 1);
woodNormal.repeat.set(1, 1);
export const matPost = new THREE.MeshStandardMaterial({
    color: '#2ecc71' // зеленый — стойки
});
export const matMauerlat = new THREE.MeshStandardMaterial({
    color: '#bc2ecc' // зеленый — стойки
});
export const matBeam = new THREE.MeshStandardMaterial({
    map: woodMap, // текстура дерева
    color: new THREE.Color('#cf8555'), // оттенок поверх текстуры
    roughness: 0.8,
    metalness: 0.0,
});
export const matBrace = new THREE.MeshStandardMaterial({
    color: '#e74c3c' // красный — раскосы
});
export function createDefaultMaterial(color) {
    return new THREE.MeshStandardMaterial({
        map: woodMap,
        color: color !== undefined ? new THREE.Color(color) : new THREE.Color('#cf8555'),
        roughness: 0.8,
        metalness: 0.0,
    });
}
